module.exports = __webpack_public_path__ + "img/sign_250010783_1.92ef7a88.png";